export enum RouteName {
  List = 'secure-provider-contracts-list',
  Create = 'secure-provider-contracts-create',
  Edit = 'secure-provider-contracts-edit',
  Detail = 'secure-provider-contracts-detail',
}
